import { Injectable } from "@angular/core";
import { IApplication } from "app/types/application";

@Injectable({ providedIn: 'root' })
export class AppsService {

  private readonly _apps: IApplication[] = [{
    id: 'airtrfx',
    link: 'airtrfx',
    text: 'airTRFX',
    logoText: "airTRFX"
  },
  {
    id: 'airmodules',
    link: 'airmodules',
    text: 'airModules',
    logoText: "airModules"
  },
  {
    id: 'farewire',
    link: 'farewire',
    text: 'FareWire',
    logoText: "airWire"
  },
  {
    id: 'emads',
    link: 'emads',
    text: 'airAds',
    logoText: "airAds"
  },
  {
    id: 'thememanager',
    link: 'settings',
    text: 'Settings',
    logoText: ""
  }];

  /**
   * Return the list of applications that is on the arr userapplist that is passing as argument
   */
  public getApplications(userapplist: string[]): Promise<IApplication[]> {
    return Promise.resolve(this.getApplicationsSync(userapplist));
  }

  public getApplicationsSync(userapplist: string[]): IApplication[] {
    return this._apps.filter(app => userapplist.includes(app.id));
  }

  public getApplication(appId: string): Promise<IApplication> {
    return Promise.resolve(this.getApplicationSync(appId));
  }

  public getApplicationSync(appId: string): IApplication {
    return this._apps.find(app => app.id == appId);
  }

  public getDefaultApp(granted: string[]): IApplication | null {
    for (const app of this._apps) {
      const found = granted.find(appId => app.id === appId);
      if (found) return app;
    }
    return null;
  }

  /** @deprecated */
  public getDefaultLink(granted: string[]): string | null {
    return this.getDefaultApp(granted)?.link || null;
  }
}
